var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.882881 2.64871L15.4504 2.64868C15.9381 2.64868 16.3333 3.04396 16.3333 3.53156C16.3333 4.01917 15.9381 4.41445 15.4505 4.41445L0.882885 4.41448C0.395282 4.41448 1.1051e-06 4.0192 0 3.5316C-1.05248e-06 3.044 0.395278 2.64872 0.882881 2.64871Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.18073 6.62158C6.66834 6.62158 7.06362 7.01686 7.06362 7.50446V12.8018C7.06362 13.2894 6.66834 13.6846 6.18073 13.6846C5.69313 13.6846 5.29785 13.2894 5.29785 12.8018V7.50446C5.29785 7.01686 5.69313 6.62158 6.18073 6.62158Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1534 6.62158C10.641 6.62158 11.0363 7.01686 11.0363 7.50446V12.8018C11.0363 13.2894 10.641 13.6846 10.1534 13.6846C9.66579 13.6846 9.27051 13.2894 9.27051 12.8018V7.50446C9.27051 7.01686 9.66579 6.62158 10.1534 6.62158Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.20808 2.64868C2.69568 2.64868 3.09096 3.04396 3.09096 3.53156V15.8919H13.2441V3.53156C13.2441 3.04396 13.6394 2.64868 14.127 2.64868C14.6146 2.64868 15.0099 3.04396 15.0099 3.53156V16.1126C15.0099 16.5224 14.8471 16.9154 14.5573 17.2052C14.2676 17.4949 13.8746 17.6577 13.4648 17.6577H2.87024C2.46047 17.6577 2.06748 17.4949 1.77773 17.2052C1.48798 16.9154 1.3252 16.5224 1.3252 16.1126V3.53156C1.3252 3.04396 1.72048 2.64868 2.20808 2.64868Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.62011 0.646476C5.03404 0.232544 5.59545 0 6.18084 0H10.1538C10.7392 0 11.3006 0.232544 11.7145 0.646476C12.1285 1.06041 12.361 1.62182 12.361 2.20721V3.53153C12.361 4.01913 11.9657 4.41441 11.4781 4.41441C10.9905 4.41441 10.5953 4.01913 10.5953 3.53153V2.20721C10.5953 2.09013 10.5487 1.97785 10.466 1.89506C10.3832 1.81227 10.2709 1.76577 10.1538 1.76577H6.18084C6.06376 1.76577 5.95148 1.81227 5.86869 1.89506C5.78591 1.97785 5.7394 2.09013 5.7394 2.20721V3.53153C5.7394 4.01913 5.34412 4.41441 4.85652 4.41441C4.36891 4.41441 3.97363 4.01913 3.97363 3.53153V2.20721C3.97363 1.62182 4.20618 1.06041 4.62011 0.646476Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.dc1d6a4e53051c456c5cacd265586472.svg";
export { ForwardRef as ReactComponent };